<template>
  <div class="my-contents">
    <span class="content-count" v-if="kind === 'origin'">{{ currentCount }} / {{ planCount }}</span>
    <div class="sub-header">
      <div
        class="sort normal-btn"
        @click="isShowSortSelect = !isShowSortSelect"
        v-on-clickaway="sortSelectAway"
      >
        並び替え
        <transition>
          <ul class="sort-option drop-down-list" v-show="isShowSortSelect">
            <li :class="{ selected: sort.index === 0 }" @click="changeSort(0, 'code', 'asc')">ID昇順</li>
            <li :class="{ selected: sort.index === 1 }" @click="changeSort(1, 'code', 'desc')">ID降順</li>
            <li :class="{ selected: sort.index === 2 }" @click="changeSort(2, 'name', 'asc')">名前昇順</li>
            <li :class="{ selected: sort.index === 3 }" @click="changeSort(3, 'name', 'desc')">名前降順</li>
            <li :class="{ selected: sort.index === 4 }" @click="changeSort(4, 'savedUserName', 'asc')">更新者名昇順</li>
            <li :class="{ selected: sort.index === 5 }" @click="changeSort(5, 'savedUserName', 'desc')">更新者名降順</li>
            <li :class="{ selected: sort.index === 6 }" @click="changeSort(6, 'savedOn', 'asc')">更新日時昇順</li>
            <li :class="{ selected: sort.index === 7 }" @click="changeSort(7, 'savedOn', 'desc')">更新日時降順</li>
            <li :class="{ selected: sort.index === 8 }" @click="changeSort(8, 'size', 'asc')">サイズ昇順</li>
            <li :class="{ selected: sort.index === 9 }" @click="changeSort(9, 'size', 'desc')">サイズ降順</li>
          </ul>
        </transition>
      </div>
      <div class="display-type normal-btn" :class="viewMode === 'tile' ? 'list' : 'tile'" @click="changeViewMode">
        {{ viewMode === 'tile' ? 'リスト' : 'タイル' }}表示
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="検索"
          v-model="model.searchText"
          @keydown.enter="$utils.event.strictEnter($event, getContentsFirstPage)"
        />
        <button @click="getContentsFirstPage"><i class="fas fa-search"></i></button>
      </div>
    </div>
    <portal v-if="isShowFolderChipsPopup" to="modal2">
      <chips-popup
        chipType="folder"
        :folders="folders"
        @close="isShowFolderChipsPopup = false"
        @chipSelect="selectFolder($event)"
      />
    </portal>
    <portal v-if="isShowTagChipsPopup" to="modal2">
      <chips-popup
        chipType="tag"
        :tags="tags"
        @close="isShowTagChipsPopup = false"
        @chipSelect="selectTag($event)"
      />
    </portal>
    <div v-if="kind == 'zip_export'" class="zips-wrapper">
      <ul class="zips">
        <li
          v-for="(zip, index) in zips.data"
          :class="{ selected: zips.select === zip.value }"
          :key="index"
          @click="selectZip(zip)"
        >
          {{ zip.name }}
        </li>
      </ul>
    </div>
    <div class="folders-wrapper">
      <ul
        class="folders"
        :style="{maxHeight: folders.height + 'px'}"
        ref="folders"
      >
        <li
          v-for="(folder, index) in sortedFoldersData"
          :class="{ selected: folders.select === folder.id }"
          :key="index"
          @click="selectFolder(folder)"
        >
          {{ folder.name }}
        </li>
      </ul>
      <div
        class="all-open"
        :class="{show: folders.heightAll > 34}"
        @click="isShowFolderChipsPopup = true"
      >
        すべてを表示
      </div>
    </div>
    <div class="tags-wrapper">
      <ul
        class="tags"
        :style="{maxHeight: tags.height + 'px'}"
        ref="tags"
      >
        <li
          v-for="(tag, index) in sortedTagsData"
          :class="{ selected: isTagSelected(tag) }"
          @click="selectTag(tag)"
          :key="index"
        >
          {{tag.name}}
        </li>
      </ul>
      <div
        class="all-open"
        :class="{show: tags.heightAll > 34}"
        @click="isShowTagChipsPopup = true"
      >
        すべてを表示
      </div>
    </div>
    <div v-if="!isNew" class="operation-area">
      <ul class="batch">
        <li v-if="contents.length > 0">
          <input
            id="all-checked"
            type="checkbox"
            @change="check = $event.target.checked"
            :checked="check !== 0 && check === contents.length"
          />
          <label for="all-checked"></label>
        </li>
        <li
          v-if="check"
          class="tag normal-btn"
          @click="tagOption = !tagOption"
          v-on-clickaway="tagHidden"
        >
          <span>タグ追加</span>
          <transition>
            <ul class="drop-down-list drop-down-list-scrollable" v-show="tagOption">
              <li> ----- </li>
              <li
                v-for="(tag, index) in limitedTagsData"
                :key="index"
                @click="addTag(tag)"
              >
                {{ tag.name }}
              </li>
            </ul>
          </transition>
        </li>
        <li
          v-if="check"
          class="batch-folder normal-btn"
          @click="batchFolderOption = !batchFolderOption"
          v-on-clickaway="batchFolderHidden"
        >
          <span>グループ変更</span>
          <transition>
            <ul class="drop-down-list drop-down-list-scrollable" v-show="batchFolderOption">
              <li> ----- </li>
              <li
                v-for="(folder, index) in folders.data"
                :key="index"
                @click="addFolder(folder)"
              >
                {{ folder.name }}
              </li>
            </ul>
          </transition>
        </li>
        <li
          v-if="check"
          class="delete normal-btn"
          @click="deleteConfirm(false)"
        >
          <span>削除</span>
        </li>
      </ul>
    </div>
    <div class="cards">
      <pagination
        :maxPageIndex="pager.last"
        :currentPageIndex="pager.current"
        @updateCurrentPageIndex="updateCurrentPageIndex"
      />
      <template v-if="!isNoContents">
        <transition>
          <div class="tile" v-if="viewMode === 'tile'">
            <template v-for="(content, index) in contents">
              <content-card-tile
                :contentType="'my'"
                :content="content"
                :id="content.id"
                :key="content.id"
                :index="index"
                :isNew="isNew"
                :kind="kind"
                :isShowInfo="mixinIsShowAsync"
                :extTypeName="extTypeName"
                @updateContentInfo="updateContentInfo"
                @toggleSave="toggleSave"
                @toggleShowInput="toggleShowInput"
                @htmlPreview="htmlPreview"
                @download="download"
                @copy="copy"
                @deleteConfirm="deleteConfirm"
                ref="tile"
              />
            </template>
          </div>
          <div class="list" v-if="viewMode === 'list'">
            <template v-for="(content, index) in contents">
              <content-card-list
                :contentType="'my'"
                :content="content"
                :id="content.id"
                :key="content.id"
                :index="index"
                :isNew="isNew"
                :kind="kind"
                :isShowInfo="mixinIsShowAsync"
                :extTypeName="extTypeName"
                @updateContentInfo="updateContentInfo"
                @toggleSave="toggleSave"
                @toggleShowInput="toggleShowInput"
                @htmlPreview="htmlPreview"
                @download="download"
                @copy="copy"
                @deleteConfirm="deleteConfirm"
                ref="list"
              />
            </template>
          </div>
        </transition>
      </template>
      <template v-else>
        <div class="no-contents">
          <p>メーリングがありません</p>
        </div>
      </template>
      <pagination
        :maxPageIndex="pager.last"
        :currentPageIndex="pager.current"
        @updateCurrentPageIndex="updateCurrentPageIndex"
      />
    </div>
    <portal v-if="isShowDeletePopup" to="modal1">
      <modal @close="isShowDeletePopup = false">
        <template slot="title">削除確認</template>
        <template slot="name">
          <p>
            メーリング {{ deletes.length }} 件を本当に削除してもよろしいでしょうか?
          </p>
          <p v-if="deletes.some(content => ['abs_export', 'mp', 'ec_v1', 'ec_v2', 'hosting'].includes(content.kind))">
            削除するとこれに紐づくホスティングデータも消えます
          </p>
        </template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="deleteContents" class="delete normal-btn">削除</button>
            <button type="button" @click="isShowDeletePopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
    <portal v-if="isDeleteLoading" to="modal1">
      <div class="delete-loading">
        <div class="spinner">
          <span>Loading...</span>
        </div>
      </div>
    </portal>
    <portal v-if="isShowZipDownloadModal" to="modal1">
      <modal @close="isShowZipDownloadModal = false">
        <template slot="title">ダウンロード</template>
        <template slot="name">
          <p>こちらからダウンロードしてください</p>
          <a class="download-link" :href="zipDownloadLink">ダウンロードリンク</a>
        </template>
      </modal>
    </portal>
  </div>
</template>

<script>
import ContentCardTile from '@/components/Content/Manager/ContentCardTile'
import ContentCardList from '@/components/Content/Manager/ContentCardList'
import ContentCheckBase from '@/components/Content/Check/ContentCheckBase'
import ChipsPopup from '@/components/Contents/ChipsPopup'
import constants from '@/constants'
import Pagination from '@/components/Util/Pagination'
import Modal from '@/components/Util/Modal'
import AsyncShowBase from '@/mixins/AsyncShowBase'
import { mixin as onClickAway } from 'vue-clickaway'

const ONE_LINE_HEIGHT = 24
const MAX_POLLING_COUNT = 5
const POLLING_INTERVAL_MILLISECONDS = 10000 // 10 * 1000

const SORTS = [
  ['code', 'asc'],
  ['code', 'desc'],
  ['name', 'asc'],
  ['name', 'desc'],
  ['savedUserName', 'asc'],
  ['savedUserName', 'desc'],
  ['savedOn', 'asc'],
  ['savedOn', 'desc'],
  ['size', 'asc'],
  ['size', 'desc'],
]

const initialData = () => {
  return {
    isNoContents: false,
    isShowSortSelect: false,
    isShowDeletePopup: false,
    isShowZipDownloadModal: false,
    isShowFolderChipsPopup: false,
    isShowTagChipsPopup: false,
    pager: {
      current: 1,
      last: 1,
    },
    zips: {
      data: [
        {
          name: '相対パス',
          value: 'rel_export',
        },
        {
          name: '絶対パス',
          value: 'abs_export',
        }
      ],
      select: 'all', // 'all' or 'rel_export' or 'abs_export'
    },
    tags: {
      data: [],
      selects: 'all', // 'all' or [('unset'), (1)]
      height: ONE_LINE_HEIGHT,
      heightAll: 0,
    },
    model: {
      searchText: '',
    },
    sort: {
      index: 1,
      target: 'code',
      type: 'desc',
    },
    folders: {
      data: [],
      select: 'all', // 'unset' or 'all' or int
      height: ONE_LINE_HEIGHT,
      heightAll: 0,
    },
    contents: [],
    deletes: [],
    isDeleteLoading: false,
    viewMode: 'tile',
    sortOption: false,
    tagOption: false,
    batchFolderOption: false,
    pollingIntervals: [],
    currentCount: 0,
    planCount: 0,
    zipDownloadLink: '',
    isCopying: false,
  }
}
export default {
  components: {
    ContentCardTile,
    ContentCardList,
    Modal,
    Pagination,
    ChipsPopup,
  },
  mixins: [
    onClickAway,
    ContentCheckBase,
    AsyncShowBase,
  ],
  props: [
    'isNew',
    'kind',
    'extTypeName',
  ],
  data () {
    return initialData()
  },
  computed: {
    isTagSelected () {
      return function (tag) {
        if (tag.id === 'all') {
          return this.tags.selects === 'all'
        } else {
          return Array.isArray(this.tags.selects) && this.tags.selects.some(select => tag.id === select)
        }
      }
    },
    check: {
      get: function () {
        return this.contents.filter(content => (content.checked)).length
      },
      set: function (value) {
        this.contents.forEach(content => { content.checked = value })
      }
    },
    limitedTagsData () {
      return this.tags.data.filter(tag => tag.name !== '未設定')
    },
    sortedFoldersData () {
      // グループ名が 未設定 > 選択されている > 選択されていない の順番でソートしています
      const [ unsetFoldersData, ...notUnsetFoldersData ] = this.folders.data
      const selectedFolders = notUnsetFoldersData.filter(folder => this.folders.select === folder.id)
      const notSelectedFolders = notUnsetFoldersData.filter(folder => this.folders.select !== folder.id)

      return unsetFoldersData == null ? [
        ...selectedFolders,
        ...notSelectedFolders,
      ] : [
        unsetFoldersData,
        ...selectedFolders,
        ...notSelectedFolders,
      ]
    },
    sortedTagsData () {
      // タグ名が 未設定 > 選択されている > 選択されていない の順番でソートしています
      const [ unsetTagsData, ...notUnsetTagsData ] = this.tags.data
      const selectedTags = notUnsetTagsData.filter(tag => this.isTagSelected(tag))
      const notSelectedTags = notUnsetTagsData.filter(tag => !this.isTagSelected(tag))
      return unsetTagsData == null ? [
        ...selectedTags,
        ...notSelectedTags,
      ] : [
        unsetTagsData,
        ...selectedTags,
        ...notSelectedTags,
      ]
    },
  },
  mounted () {
    // v1もecでリクエストが来る
    if (this.$route.query.from === 'ec' && this.$route.query.code) {
      // 検索窓にcodeを入力
      this.model.searchText = this.$route.query.code
    }
    this.initComponent()
  },
  methods: {
    initComponent () {
      this.mixinAsyncShow('contents')
      this.getDefaultDisplay().then(() => {
        this.getContentsFirstPage()
        this.getTags()
        this.getFolders()
      })
    },
    updateCurrentPageIndex (index) {
      if (index > this.pager.total || index < 1) return
      this.pager.current = index
      this.getContents()
    },
    sortSelectAway () {
      this.isShowSortSelect = false
    },
    changeSort (index, target, type) {
      this.isShowSortSelect = false
      this.sort = { index, target, type }
      this.getContentsFirstPage()

      // 並び替え設定を保存
      const formData = new FormData()
      if (this.isNew) {
        formData.append('contentNewSortTarget', target)
        formData.append('contentNewSortType', type)
      } else {
        formData.append('contentSortTarget', target)
        formData.append('contentSortType', type)
      }
      this.$http({
        url: '/user/mphe_settings/change_default_display',
        type: 'POST',
        params: formData,
      })
    },
    changeViewMode () {
      this.viewMode = this.viewMode === 'tile' ? 'list' : 'tile'
      this.$nextTick(() => {
        // imgのDOMが取れなくなるため、再度ポーリング && エラー画像セットを行う
        clearInterval(this.pollingIntervals)
        this.capturePolling()

        // タイル or リスト 表示設定を保存
        const formData = new FormData()
        if (this.isNew) {
          formData.append('contentNewViewMode', this.viewMode)
        } else {
          formData.append('contentViewMode', this.viewMode)
        }
        this.$http({
          url: '/user/mphe_settings/change_default_display',
          type: 'POST',
          params: formData,
        })
      })
    },
    getDefaultDisplay () {
      let url = null
      if (this.isNew) {
        url = `/user/mphe_settings/default_display_${this.kind !== 'origin' ? 'content_new' : 'content/origin'}`
      } else {
        url = `/user/mphe_settings/default_display_content/${this.kind}`
      }
      return this.$http({
        url,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          const { viewMode, sortTarget, sortType, grepTags, grepFolder, zipKind } = json.data.display
          this.viewMode = viewMode
          this.sort = {
            index: SORTS.findIndex(sort => sort[0] === sortTarget && sort[1] === sortType),
            target: sortTarget,
            type: sortType
          }
          this.tags.selects = grepTags.length ? grepTags : 'all'
          this.folders.select = grepFolder || 'all'
          this.zips.select = zipKind || 'all'
        }
        return json
      })
    },
    getContents () {
      const urlSP = new URLSearchParams()
      urlSP.append('kind', this.kind)
      urlSP.append('searchText', this.model.searchText)
      urlSP.append('sortTarget', this.sort.target)
      urlSP.append('sortType', this.sort.type)
      urlSP.append('folder', this.folders.select)
      urlSP.append('page', this.pager.current)
      urlSP.append('zipKind', this.zips.select)
      if (this.tags.selects === 'all') {
        urlSP.append('tags', 'all')
      } else {
        this.tags.selects.forEach(select => {
          urlSP.append('tags[]', select)
        })
      }
      return this.$http({
        url: `/content?${urlSP.toString()}`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.contents = json.data.contents.map(content => {
            const tags = content.tags.map(tag => {
              return {
                ...tag,
                name: this.$utils.string.b64Decode(tag.name)
              }
            })
            return {
              ...content,
              name: this.$utils.string.b64Decode(content.name),
              captureUrl: decodeURIComponent(content.captureUrl),
              tags,
              checked: false,
              showInput: {
                name: false,
              },
            }
          })
          this.isNoContents = (this.contents.length === 0)
          this.currentCount = json.data.currentCount
          this.planCount = json.data.planCount
          this.pager.last = json.data.lastPage
          this.$nextTick(() => {
            this.capturePolling()
          })
        }
      })
    },
    getContentsFirstPage () {
      this.pager.current = 1
      this.getContents()
    },
    async capturePolling () {
      if (!this.$refs[this.viewMode]) {
        // 表示メーリングがない場合はスキップ
        return
      }
      this.$refs[this.viewMode].forEach(async (comp, index) => {
        const img = comp.$refs.capture
        const content = this.contents[index]
        let isCompleted = false
        img.addEventListener('load', () => {
          if (!isCompleted && img.complete) {
            if (!content.enablePolling) {
              return
            }
            this.startPolling(img, content)
            isCompleted = true
          }
        }, { once: true })
        img.addEventListener('error', () => {
          if (!isCompleted && img.complete) {
            this.startPolling(img, content)
            isCompleted = true
          }
        }, { once: true })
      })
    },
    async startPolling (img, content) {
      let count = 0
      const result = await this.getCapture(img, content, ++count)
      if (!result) {
        const pollingInterval = setInterval(
          async () => {
            count > MAX_POLLING_COUNT && clearInterval(pollingInterval)
            await this.getCapture(img, content, ++count) && clearInterval(pollingInterval)
          },
          POLLING_INTERVAL_MILLISECONDS
        )
        this.pollingIntervals.push(pollingInterval)
      }
    },
    async getCapture (img, content, count) {
      const resp = await fetch(content.captureUrl, {
        method: 'GET',
        headers: {
          'Range': 'bytes=0-100',
        },
        mode: 'cors'
      })
      const lastModified = resp.headers.get('Last-Modified')
      const uLastModified = Math.floor(new Date(lastModified).getTime() / 1000)
      const enqueuedOn = content.captureEnqueuedOn
      if (!resp.ok || enqueuedOn > uLastModified) {
        // キャプチャ画像が未生成 OR (エンキュー日時 > キャプチャ画像のLast-Modified) の時、ポーリング続行
        img.src = '../../../../static/loading.png'
        return false
      } else {
        // ポーリング終了
        if (count > 1) {
          // 署名URLだと適当なクエリパラメータがつけられない(403が返る)ので、#をつける
          img.src = content.captureUrl + '#' + count
        }
        return true
      }
    },
    async htmlPreview (content) {
      const { href } = this.$router.resolve(`/${this.$route.params.mpDomain}/${this.$route.params.siteId}/content/preview/` + content.id)
      window.open(href, '_blank')
    },
    async download (content) {
      // zipの再ダウンロード
      await this.$store.dispatch('getContent', content.id)
      let sections = null
      if (content.kind === 'rel_export') {
        sections = this.$store.getters.getSectionAll
      } else {
        sections = await this.getAbsDownloadPublicSections(content.id)
      }
      this.createRawHTML(sections)
      this.mobileCSS = this.createMobileCSS()
      const formData = new FormData()
      formData.append('body', this.rawHTML)
      formData.append('contentId', content.id)
      formData.append('title', this.$store.getters.getContentInfo.name)
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      formData.append('headCss', this.createHeadCSS())
      formData.append('outlookCss', this.createOutlookCSS())
      formData.append('localExportOption', content.kind === 'rel_export' ? 'relative' : 'absolute')

      const json = await this.$http({
        url: '/zip_content/download',
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        if (json.data.link) {
          this.zipDownloadLink = json.data.link
          this.isShowZipDownloadModal = true
        }
      }
    },
    copy (content) {
      if (this.isCopying) return
      this.isCopying = true
      const formData = new FormData()
      formData.append('contentId', content.id)
      this.$http({
        url: '/content/copy',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.$router.push({ path: `/${this.$route.params.mpDomain}/${this.$route.params.siteId}/content/edit/${json.data.contentId}` })
        }
        this.isCopying = false
      })
    },
    deleteConfirm (content = false) { // 明示的に指定
      // 単体で削除 or チェックボックスで選択
      this.deletes = content ? [ content ] : this.contents.filter(content => (content.checked))
      this.isShowDeletePopup = true
    },
    deleteContents () {
      const formData = new FormData()
      this.deletes.map(content => {
        formData.append('contentIds[]', content.id)
        return content.id
      })
      this.isDeleteLoading = true
      this.$http({
        url: '/content/delete',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          if (json.data && json.data.ecApiErrorMessages) {
            this.$store.commit('showErrorMessagePopup', json.data.ecApiErrorMessages)
          }
          this.getTags()
          this.getContents().then(() => {
            if (this.pager.current > this.pager.last) {
              // 現在のページが最後のページより後ろなら前のページに戻る
              this.pager.current--
              this.getContents()
            }
          })
        }
        this.deletes = []
        this.isShowDeletePopup = false
        this.isDeleteLoading = false
      })
    },
    toggleSave (content, kind) {
      this.toggleShowInput(content, kind)
      this.$nextTick(() => {
        if (!content.showInput[kind]) {
          this.updateContentInfo(content)
        }
      })
    },
    toggleShowInput (content, kind, index) {
      content.showInput[kind] = !content.showInput[kind]
      this.$nextTick(() => {
        if (content.showInput[kind]) {
          this.$refs[this.viewMode][index].$refs[kind + index].focus()
        }
      })
    },
    updateContentInfo (content) {
      if (content.name === '') {
        this.getContents()
        return this.$store.commit('showErrorMessagePopup', ['件名が入力されていません'])
      }
      content.name = content.name.replace(/\r?\n/g, '')
      const formData = new FormData()
      formData.append('name', this.$utils.string.b64Encode(content.name))
      this.$http({
        url: '/content/save_info/' + content.id,
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          content.savedUserName = json.data.savedUserName
          content.savedOn = json.data.savedOn
        } else {
          this.getContents()
        }
      })
    },
    selectZip (zip) {
      if (this.zips.select === zip.value) {
        // 同じものが選ばれた場合は選択を解除する
        this.zips.select = 'all'
      } else {
        // 絞り込み
        this.zips.select = zip.value
      }
      this.getContentsFirstPage()
    },
    getFolders () {
      return this.$http({
        url: `/folder/content?sortTarget=manual&sortType=asc`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.folders.data = [
            {
              id: 'unset',
              name: '未設定',
            },
            ...json.data.folders.map(folder => {
              return {
                ...folder,
                name: this.$utils.string.b64Decode(folder.name)
              }
            })
          ]
          this.$nextTick(() => {
            if (!this.$refs.folders) return
            this.folders.heightAll = this.$refs.folders.scrollHeight
          })
        }
      })
    },
    addFolder (folder) {
      const formData = new FormData()
      this.contents.filter(content => (content.checked)).map(content => {
        formData.append('targetIds[]', content.id)
      })
      formData.append('folder', folder.id)
      this.$http({
        url: '/folder/add/content',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.getContentsFirstPage()
        }
      })
    },
    selectFolder (folder) {
      if (this.folders.select === folder.id) {
        // 同じグループが選ばれた場合はグループ選択を解除する
        this.folders.select = 'all'
      } else {
        // グループ絞り込み
        this.folders.select = folder.id
      }
      this.getContentsFirstPage()
    },
    getTags () {
      return this.$http({
        url: `/tag?kind=${this.kind}`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.tags.data = [
            {
              id: 'unset',
              name: '未設定',
            },
            ...json.data.tags.map(tag => {
              return {
                ...tag,
                name: this.$utils.string.b64Decode(tag.name)
              }
            })
          ]
          this.$nextTick(() => {
            if (!this.$refs.tags) return
            this.tags.heightAll = this.$refs.tags.scrollHeight
          })
        }
      })
    },
    addTag (newTag) {
      // 選択されたコンテンツのタグの最大数
      const maxTagsCount = Math.max(...this.contents.filter(content => (content.checked)).map(content => content.tags.length))

      if (constants.maxTagsCount <= maxTagsCount) {
        this.$store.commit(
          'showErrorMessagePopup',
          ['タグは最大' + constants.maxTagsCount + '個までです']
        )
      } else {
        const formData = new FormData()
        this.contents.filter(content => (content.checked)).map(content => {
          formData.append('contentIds[]', content.id)
        })
        formData.append('kind', this.kind)
        formData.append('tagId', newTag.id)
        this.$http({
          url: `/tag/add`,
          type: 'POST',
          params: formData,
        }).then(json => {
          if (json && json.status === 200) {
            this.getContents()
          }
        })
      }
    },
    selectTag (tag) {
      if (tag.id === 'all') {
        this.tags.selects = 'all'
      } else {
        if (this.tags.selects === 'all') {
          this.tags.selects = [tag.id]
        } else if (this.tags.selects.some(select => select === tag.id)) {
          this.tags.selects = this.tags.selects.filter(select => select !== tag.id)
        } else {
          this.tags.selects = [ ...this.tags.selects, tag.id ]
        }
      }
      this.getContentsFirstPage()
    },
    tagHidden () {
      this.tagOption = false
    },
    batchFolderHidden () {
      this.batchFolderOption = false
    },
  },
  beforeDestroy () {
    this.$store.commit('clearStateToLeaveContentsList')
    this.pollingIntervals.forEach(interval => clearInterval(interval))
  },
  watch: {
    kind () {
      Object.assign(this.$data, initialData())
      this.initComponent()
    }
  }
}
</script>

<style lang="scss" scoped>
.my-contents {
  font-size: 14px;
  position: relative;
  .content-count {
    position: absolute;
    top: -42px;
    left: 20px;
    font-size: 12px;
    display: inline-block;
    padding: 0 8px;
    height: 22px;
    line-height: 22px;
    border-radius: 13px;
    background: #e4e4e4;
  }
  h5 {
    padding-left: 20px;
    margin-bottom: 50px;
    font-size: 24px;
    span {
      font-size: 12px;
      display: inline-block;
      padding: 0 8px;
      margin-left: 8px;
      height: 22px;
      line-height: 22px;
      border-radius: 13px;
      background: #e4e4e4;
    }
  }
  .sub-header {
    position: absolute;
    top: -122px;
    right: 0;
    text-align: right;
    pointer-events: none;
    > div:not(.search) {
      display: inline-block;
      margin-bottom: 20px;
      pointer-events: auto;
    }
    .search {
      width: 400px;
      height: 35px;
      display: block;
      position: relative;
      margin-right: 20px;
      pointer-events: auto;
      &>input {
        width: 100%;
        padding:0 10px;
        border-radius:2px;
        height: 35px;
        outline:0;
        background: #E4E4E4;
        position: absolute;
        left: 0;
        top: 0;
      }
      &>button {
        width: 50px;
        height: 35px;
        border-radius:0 2px 2px 0;
        outline:0;
        position: absolute;
        right: -20px;
        top: 0;
        background: none;
        transition: all 0.3s ease 0s;
        cursor: pointer;
        &:hover, &:active {
          background: #c6c6c6;
          transition: all 0.3s ease 0s;
        }
      }
    }
    .sort {
      &::before {
        content: '\f161';
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      .sort-option {
        right: 0;
        width: 83px;
        li {
          position: relative;
          width: 100%;
          &.selected::before {
            content: '\f00c';
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            position: absolute;
            top: 0;
            left: -15px;
          }
        }
      }
    }
    .display-type {
      &::before {
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      &.tile {
        &::before {
          content: '\f00a';
          padding-right: 4px;
        }
      }
      &.list {
        &::before {
          content: '\f03a';
        }
      }
    }
  }
  .no-contents {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
    }
  }
  // フォルダへのリンク
  .zips-wrapper {
    display:-webkit-box;
    display:flex;
    margin: 20px 0 20px 20px;
    .zips {
      height: 24px;
      margin: 0;
      display:-webkit-box;
      display: flex;
      flex-wrap: wrap;
      transition: all 0.3s ease 0s;
      overflow: hidden;
      &::before {
        font-family: "Font Awesome 5 Free";
        content: '\f1c6';
        font-weight: 900;
      }
      li {
        display: inline-block;
        cursor: pointer;
        margin: 0 10px 10px 0;
        transition: all 0.3s ease 0s;
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 10px;
        background: #fff;
        border-radius: 2px;
        &:hover {
          background: rgba($primaryHoverColor, 0.4);
        }
        &:first-of-type {
          margin-left: 10px;
        }
        &.selected {
          color: #fff;
          background: $primaryActiveColor;
          &:hover {
            background: $primaryHoverColor;
          }
        }
      }
    }
  }
  // フォルダへのリンク
  .folders-wrapper {
    display:-webkit-box;
    display:flex;
    margin: 20px 0 20px 20px;
    .folders {
      height: 24px;
      margin: 0;
      display:-webkit-box;
      display: flex;
      flex-wrap: wrap;
      transition: all 0.3s ease 0s;
      overflow: hidden;
      &::before {
        font-family: "Font Awesome 5 Free";
        content: '\f5fd';
        font-weight: 900;
      }
      li {
        display: inline-block;
        cursor: pointer;
        margin: 0 10px 10px 0;
        transition: all 0.3s ease 0s;
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 10px;
        background: #fff;
        border-radius: 2px;
        &:hover {
          background: rgba($primaryHoverColor, 0.4);
        }
        &:first-of-type {
          margin-left: 10px;
        }
        &.selected {
          color: #fff;
          background: $primaryActiveColor;
          &:hover {
            background: $primaryHoverColor;
          }
        }
      }
    }
  }
  // タグ機能
  .tags-wrapper {
    display:-webkit-box;
    display:flex;
    margin: 0 0 25px 20px;
    .tags {
      margin: 0;
      height: 24px;
      display:-webkit-box;
      display: flex;
      flex-wrap: wrap;
      transition: all 0.3s ease 0s;
      overflow: hidden;
      &::before {
        font-family: "Font Awesome 5 Free";
        content: '\f02b';
        font-weight: 900;
      }
      li {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 10px;
        cursor: pointer;
        margin: 0 10px 10px 0;
        background: #fff;
        border-radius: 12px;
        transition: all 0.3s ease 0s;
        &:first-of-type {
          margin-left: 10px;
        }
        &:hover {
          background: rgba($primaryHoverColor, 0.4);
        }
        &.selected {
          color: #fff;
          background: $primaryActiveColor;
          &:hover {
            background: $primaryHoverColor;
          }
        }
      }
    }
  }
  // すべてを表示 ボタン
  .all-open {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    display: inline-block;
    padding: 0 10px;
    flex-shrink: 0;
    border-radius: 12px;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    visibility: hidden;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f022';
      font-weight: 900;
    }
    &.show {
      visibility: visible;
    }
    &:hover, &:active {
      background: #e4e4e4;
      transition: all 0.3s ease 0s;
    }
  }
  // 一括操作・検索・表示型切り替えボタン
  .operation-area {
    display:flex;
    align-items: center;
    // 一括操作のチェックボックス
    input[type=checkbox] {
      display:  none;
      + label {
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
        box-sizing: border-box;
      }
    }
    .batch {
      display:flex;
      margin: 0 0 0 20px;
      li:not(:first-of-type) {
        span {
          display: inline-block;
          &::before, &::after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
          }
          &::before {
            padding-right: 5px;
          }
        }
        &.tag::after, &.batch-folder::after {
          font-family: "Font Awesome 5 Free";
          font-weight: 900;
          content: '\f107';
          padding-left: 5px;
        }
        &.tag {
          &::before {
            content: '\f067';
            color: #fff;
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            position: absolute;
            top: 18px;
            left: 17.5px;
            z-index: 1;
            transform: translateY(-50%) scale(0.5, 0.5);
          }
          span{
            position: relative;
            &::before {
              content: '\f02b';
            }
          }
        }
        &.batch-folder {
          width: auto;
          span::before {
            content: '\f5fd';
          }
        }
        &.delete {
          width: 80px;
          span::before {
            content: '\f2ed';
          }
        }
      }
      > li:first-of-type {
        padding: 7.5px 0;
      }
      // ドロップダウンリストクリック時のアニメーション
      .v-enter-active, .v-leave-active {
        transition: all .1s;
      }
      .v-enter,.v-leave-to {
        height: 0;
        opacity: 0;
      }
      .v-enter-to, .v-leave {
        height: 152px;
        opacity: 1;
      }
    }
  }
  // タイル表示のときだけ横並び
  .tile {
    display:-webkit-box;
    display:flex;
    flex-wrap: wrap;
  }
  // 表示型切り替えボタンクリック時のアニメーション
  .v-enter-active {
    transition: opacity .3s ease-in-out;
  }
  .v-enter, .v-leave, .v-leave-to {
    opacity: 0;
  }
  .v-enter-to {
    opacity: 1;
  }
}

.delete-loading {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
}

// モーダルの中身
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}

.download-link {
  color: blue;
}
</style>
